import { useEffect, useRef, useState, useCallback } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import box from "../../../assets/images/website-flow/rectangle.png";
import deleteIcon from "../../../assets/images/website-flow/delete-icon.png";
import useWindowSize from "../../../hooks/useWindowSize";
import ScreenLoader from "../../common/ScreenLoader";
import axios from "axios";
import BackdropLoader from "../../common/BackdropLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { post } from "../../../services/apiService";
import { toast } from "react-toastify";
import {
  getOneMonthFromToday,
  getOneYearFromToday,
} from "../../../utils/utils";
import i18next from "i18next";

const styles = {
  cardLeft: {
    backgroundColor: "#EFF5FF80",
    borderRadius: "20px",
    fontFamily: "Tajawal-Regular",
    padding: "16px",
  },
  cardRight: {
    backgroundColor: "#EFF5FF",
    borderRadius: "20px",
    fontFamily: "Tajawal-Bold",
    padding: "16px",
  },
  "currency-btn": {
    background:
      "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
    color: "white",
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    fontFamily: "Tajawal-Bold",
    padding: "12px 24px",
    textAlign: "center",

    width: "80%",
  },
  button: {
    background:
      "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
    color: "white",
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    fontFamily: "Tajawal-Bold",
    padding: "12px 24px",
    textAlign: "center",

    width: "80%",
  },
  "select-button": {
    background:
      "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
    color: "white",
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    fontFamily: "Tajawal-Bold",
    padding: "12px 24px",
    textAlign: "center",
    width: "250px",
  },
  price: {
    fontSize: "20px",
    fontWeight: "bold",
    fontFamily: "Tajawal-Bold",
    color: "#004D8A",
  },
  heading: {
    fontSize: "24px",
    color: "black",
    fontFamily: "Tajawal-Bold",
    textWrap: "nowrap",
  },
  subText: {
    textAlign: "left",
    fontSize: "20px",
    color: "black",
    fontFamily: "Tajawal-Bold",
  },
};

const Checkout = ({
  onReadyPay,
  onDeletePlan,
  userSelectedPlan,
  subscriptionDurationValue,
  subTotal,
  domainPrice,
  onUpdateSubscriptionVaue,
  onUpdateSubTotal,
  onUpdateDomainPrice,
  onSelectPlan,
  showPlansListing,
  showSelectPlanButton,
  isLoading,
  actualAmount,
  domainName,
  domainExpiryDate,
  onSuccessfullPayment,
  onPendingTransaction,
  userInfo,
  vat,
  planPricing,
  onUpdatePlanPricing 
  // domainInfo
}) => {
  let durations =
    userSelectedPlan?.planPriceType === "monthly"
      ? [
          { label: "1 Month", value: 1 },
          { label: "2 Months", value: 2 },
          { label: "3 Months", value: 3 },
          { label: "4 Months", value: 4 },
          { label: "5 Months", value: 5 },
          { label: "6 Months", value: 6 },
        ]
      : [
          { label: "1 Year", value: 1 },
          { label: "2 Years", value: 2 },
          { label: "3 Years", value: 3 },
        ];

  const { width } = useWindowSize();

  const [currency, setCurrency] = useState(
    sessionStorage.getItem("currency") || "USD"
  );
  const navigate = useNavigate();
  const [backdropLoader, setBackdropLoader] = useState(false);
  const [usdToSAR, set1USDToSAR] = useState(3.75);
  const previousCurrencyRef = useRef(currency); // Store previous state
  const previousCurrency = previousCurrencyRef.current;
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("tenantId");
  const paymentId = searchParams.get("paymentId");
  const [currentDurationNumber, setCurrentDurationNumber] = useState(1);

  //sub total change handler
  const handleChange = (event) => {
    const subscriptionDurationValue = parseInt(event.target.value);
    setCurrentDurationNumber(subscriptionDurationValue);
    onUpdateSubscriptionVaue(subscriptionDurationValue);

    let newPricingPlan;
    if (previousCurrency === "USD" && currency === "USD") {
      newPricingPlan = actualAmount * subscriptionDurationValue;
    } else if (previousCurrency === "USD" && currency === "SAR") {
      newPricingPlan = actualAmount * usdToSAR * subscriptionDurationValue;
    } else if (previousCurrency === "SAR" && currency === "USD") {
      newPricingPlan = (actualAmount / usdToSAR) * subscriptionDurationValue;
    } else {
      newPricingPlan = actualAmount * subscriptionDurationValue;
    }
    //for already registered or existind domain (2nd or 3rd option) as there will be no domain Price therefore we need to set subTotal 
    if(userInfo?.domain?.domainStatus === 'registered' || userInfo?.domain?.domainStatus === 'personal') {
      onUpdateSubTotal(newPricingPlan);
      onUpdatePlanPricing(newPricingPlan)
    }
    else {
      onUpdatePlanPricing(newPricingPlan);
      const updatedSubTotal = (newPricingPlan + domainPrice).toFixed(2);
      onUpdateSubTotal(updatedSubTotal);
    }
   
  }
  
  const handleCurrencyChange = async () => {
    const newCurrency = currency === "USD" ? "SAR" : "USD";
    setBackdropLoader(true);

    try {
      const response = await axios.get(`https://open.er-api.com/v6/latest/USD`);
      if (response.status === 200) {
        const exchangeRate = response.data.rates.SAR; // 1 USD to SAR
        set1USDToSAR(exchangeRate);

        let newPlanPricing = planPricing;
        let newDomainPrice = domainPrice;
        if (currency === "USD" && newCurrency === "SAR") {
          newPlanPricing = planPricing * exchangeRate;
          newDomainPrice = domainPrice * exchangeRate;
        } else if (currency === "SAR" && newCurrency === "USD") {
          newPlanPricing = planPricing / exchangeRate;
          newDomainPrice = domainPrice / exchangeRate;
        }
        onUpdateSubTotal(newPlanPricing + newDomainPrice);
        onUpdateDomainPrice(newDomainPrice);
        onUpdatePlanPricing(newPlanPricing);
        setCurrency(newCurrency);
      }
    } catch (error) {
      console.error("Currency conversion failed:", error);
    } finally {
      setBackdropLoader(false);
    }
  };

  const freeServices = [
    "PAYMENT_PAGE_ITEM_MOBILE_FRIENDLY",
    "PAYMENT_PAGE_ITEM_MULTIPLE_THEMES",
    "PAYMENT_PAGE_ITEM_CONTENT",
    "PAYMENT_PAGE_ITEM_INTEGRATION_SOCIAL_MEDIAS",
  ];

  const onLoading = (isLoading) => {
    setBackdropLoader(isLoading);
  };

  // Wrap getPaymentStatus in useCallback to prevent unnecessary re-renders
  const getPaymentStatus = useCallback(async () => {
    const object = {
      paymentId: paymentId,
      userId: Number(userId),
      userPlanId: Number(userInfo?.userPlan?.id),
    };

    try {
      const response = await post("payments/status", object, {}, onLoading);
      if (response?.data?.InvoiceStatus === "Paid") {
        // navigate to '/sucess-payment'
        const paymentDetails = {
          customerName: response.data.CustomerName,
          transactionId: response.data.InvoiceTransactions[0].TransactionId,
          transactionTime: response.data.InvoiceTransactions[0].TransactionDate,
          paymentMethod: "Bank Transfer",
          paidAmount: parseFloat(
            response.data.InvoiceTransactions[0].PaidCurrencyValue.replace(
              /,/g,
              ""
            )
          ),
          paidCurrency: response.data.InvoiceTransactions[0].PaidCurrency,
          serviceCharges: Number(
            response.data.InvoiceTransactions[0].TotalServiceCharge
          ),
          message: "Transaction Successfull",
        };
        onSuccessfullPayment(true, paymentDetails);
      } else if (
        response?.data?.InvoiceStatus === "Pending" &&
        response?.data?.InvoiceTransactions[0]?.TransactionStatus === "Failed"
      ) {
        // stays on Checkout screen
        navigate("/website-flow");
        toast.error(
          `Transaction is Failed due to ${response.data.InvoiceTransactions[0].Error}, Kindly try Again`
        );

        // setOpenPaymentDialogue(true);
      } else if (
        response?.data?.InvoiceStatus === "Pending" &&
        response?.data?.InvoiceTransactions[0]?.TransactionStatus ===
          "Processing"
      ) {
        // stays on Checkout screen
        navigate("/website-flow");
        toast.info(
          `Transaction is in progress, Kindly wait for it to avoid double payment`
        );
        onPendingTransaction(true);

        // setOpenPaymentDialogue(true);
      }
    } catch (error) {
      console.log(
        "error file fetching payment status------------>",
        error.response?.data?.message
      );
    }
  }, [paymentId, userId, userInfo?.userPlan?.id, navigate, onSuccessfullPayment, onPendingTransaction]); // Add all dependencies used inside the function

  useEffect(() => {
    if (paymentId) {
      console.log("getPayment status  is called-------------->");
      getPaymentStatus();
    }
  }, [paymentId, getPaymentStatus]); // Now getPaymentStatus is stable due to useCallback

  return (
    <Grid
      container
      spacing={4}
      sx={{ paddingLeft: "5%", paddingRight: "5%", paddingBottom: "5%" }}
    >
      {/* Left Section */}
      {backdropLoader && <BackdropLoader />}
      {isLoading ? (
        <ScreenLoader />
      ) : userSelectedPlan?.subTotal && !showPlansListing ? (
        <Grid item size={{ md: 8, xs: 12 }}>
          <Typography sx={styles.heading}>{i18next.t("PAYMENT_PAGE_HEADING_1")}</Typography>
          <Card
            sx={styles.cardLeft}
            elevation={3}
            style={{ marginTop: "20px" }}
          >
            <CardContent>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Grid item sx={{ display: "flex", width: "30%", gap:3 }}>
                  <img src={box} alt="box" style={{ marginRight: "2%" }} />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                     
                      width: width > 600 ? "70%" : "50%",
                      // background:"grey"
                    }}
                  >
                    {width > 600 && (
                      <Typography sx={styles.heading} mb={2}>
                        {userSelectedPlan?.plan?.planName}
                      </Typography>
                    )}
                    <Select
                      value={subscriptionDurationValue}
                      onChange={handleChange}
                      id="select"
                      sx={{ width: "250px" }}
                    >
                      {durations.map((duration) => (
                        <MenuItem key={duration.value} value={duration.value}>
                          {duration.label.split(" ")[0]} {i18next.t(duration.label.split(" ")[1])}
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography variant="body2" mt={2}>
                      {i18next.t("Expiry Date")}:{" "}
                      {userSelectedPlan?.planPriceType === "monthly"
                        ? getOneMonthFromToday(currentDurationNumber)
                        : getOneYearFromToday(currentDurationNumber)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Typography sx={styles.price}>
                    {planPricing} {currency}
                  </Typography>
                  <img
                    src={deleteIcon}
                    alt="delete"
                    style={{ cursor: "pointer" }}
                    onClick={() => onDeletePlan(userSelectedPlan?.plan?.id)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          {domainPrice > 0 && (
            <Card
              sx={styles.cardLeft}
              elevation={3}
              style={{ marginTop: "20px" }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={styles.subText}>
                      {i18next.t("PAYMENT_PAGE_DOMAIN_TEXT")}: {domainName}
                    </Typography>
                    <Typography sx={styles.subText}>
                    {i18next.t("PAYMENT_PAGE_EXPIRY_DATE_TEXT")}: {getOneYearFromToday(1)}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ color: "#004D8A" }}>
                      {domainPrice} USD / Year
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )}
          {freeServices.map((service, index) => {
            return (
              <Card
                key={index} // Added key prop
                sx={styles.cardLeft}
                elevation={3}
                style={{ marginTop: "20px" }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography sx={styles.subText}>{i18next.t(service)}</Typography>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography sx={{ color: "#004D8A" }}>{i18next.t("PAYMENT_PAGE_FREE_TEXT")}</Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Grid>
      ) : (
        showSelectPlanButton && (
          <Grid item size={{ xs: 12 }} sx={{ height: "500px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                // backgroundColor: "grey",
              }}
            >
              <Box sx={{ flexDirection: "column" }}>
                <Button
                  sx={styles["select-button"]}
                  onClick={() => onSelectPlan(true)}
                >
                  {i18next.t("PAYMENT_PAGE_USER_INFORMATION")}
                </Button>
                <Typography
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    fontFamily: "Tajawal-Regular",
                    marginTop: "3%",
                    fontSize: "17px",
                  }}
                >
                 {i18next.t("PAYMENT_PAGE_PLAN_SELECTION")}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )
      )}

      {/* Right Section */}
      {userSelectedPlan?.subTotal && !showPlansListing && (
        <Grid item size={{ md: 4, xs: 12 }} sx={{ marginTop: "3%" }}>
          <Card sx={styles.cardRight} elevation={3}>
            <CardContent>
              <Typography
                sx={{
                  fontSize: "24px",
                  color: "black",
                  fontFamily: "Tajawal-Bold",
                  marginTop: "5%",
                }}
              >
              {i18next.t("PAYMENT_PAGE_SUMMARY_HEADING_1")}
              </Typography>
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "black",
                  fontFamily: "Tajawal-Regular",
                }}
              >
                {domainPrice > 0 ? "2 Items" : i18next.t("PAYMENT_PAGE_SUMMARY_HEADING_2")}
              </Typography>
              <hr></hr>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_PLAN_PRICE")} ({currency})
                </Typography>
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                  {planPricing} {currency}
                </Typography>
              </Box>
              {domainPrice > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      fontFamily: "Tajawal-Bold",
                      color: "black",
                    }}
                  >
                  {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_DOMAIN_PRICE")}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      fontFamily: "Tajawal-Bold",
                      color: "black",
                    }}
                  >
                    {domainPrice} {currency}
                  </Typography>
                </Box>
              )}
              {/* <hr></hr>
              {domainPrice > 0 ? "2 Items" : "Single Item"}
             
              <hr></hr> */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                  {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_SUBTOTAL")} ({currency})
                </Typography>
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                  {subTotal} {currency}
                </Typography>
              </Box>
           
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_VAT")}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                  {vat} %
                </Typography>
              </Box>
              <hr></hr>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_TOTAL_AMOUNT_PAY")}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                  }}
                >
                {(subTotal * (1 + vat / 100)).toFixed(2)} {currency}
                </Typography>
              </Box>
              <Box sx={{ marginTop: "2%" }}>
                <Typography
                  onClick={handleCurrencyChange}
                  sx={{
                    color: "#004D8A",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {currency === "USD" ? i18next.t("PAYMENT_PAGE_SUMMARY_LABEL_CONVERT_TO_SAR") : i18next.t("PAYMENT_PAGE_SUMMARY_LABEL_CONVERT_TO_USD")}
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: "12px",
                  marginTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Tajawal-Light",
                  color: "black",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
               {i18next.t("PAYMENT_PAGE_SUMMARY_LABEL_TEXT_1")}
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  marginTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Tajawal-Light",
                  color: "black",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
              {i18next.t("PAYMENT_PAGE_SUMMARY_LABEL_TEXT_2")}
              </Typography>
              <Box
                sx={{
                  justifyContent: "center",
                  textAlign: "center",
                  marginTop: "8%",
                  marginBottom: "12%",
                }}
              >
                <Button
                  sx={styles.button}
                  fullWidth
                  onClick={() => {
                    onReadyPay({
                      planId: userSelectedPlan?.plan?.id,
                      planPriceType: userSelectedPlan?.planPriceType,
                      subscriptionDuration: subscriptionDurationValue,
                      skipUpdatingStep: true,
                    });
                  }}
                >
                {i18next.t("PAYMENT_PAGE_BUTTON_LABEL_PAY")}
                  
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default Checkout;